// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___33LMB","input":"styles__input___EChqE","createNewButton":"styles__createNewButton___24hMg","label":"styles__label___19biQ"};